import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF';
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI';

const SendCustomEmailModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    submitted, sendCustomEmailMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    email, onEmailChange, emailError, setEmailError,
    message, onMessageChange, messageError, setMessageError,
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Send Custom Email'
        buttonLabel='Send'
        cancelLabel='Cancel'
        isOpen={sendCustomEmailMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputReadOnlyUI type='text' name='email' label='Email'
            maxLength={40} required={true}
            value={email} onChange={onEmailChange}
            error={emailError} setError={setEmailError}
        />
        <InputTextAreaSF type='text' name='message' label='Message'
            value={message} onChange={onMessageChange}
            error={messageError} setError={setMessageError}
        />
    </ModalFormUI>;

export default SendCustomEmailModalUI;
